// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./highlight.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --lapis: #1e3a8a;
  --parchment: #f4e9d8;

  --bg-deep: #0a1028;
  --bg-panel: #101b3d;
  --bg-raised: #152352;
  --bg-lapis: #1e3a8a;

  --text: #f4e9d8;
  --text-muted: #b8aa96;
  --text-on-lapis: #f4e9d8;

  --accent: #4b6fd4;
  --accent-hover: #6b8fe8;
  --accent-soft: #2e4a9e;
  --glow: rgba(107, 143, 232, 0.55);
  --glow-soft: rgba(75, 111, 212, 0.25);
  /** Dark halo so type stays legible over bright 3D cells behind the overlay. */
  --text-shadow-readability:
    0 2px 4px rgba(10, 16, 40, 1),
    0 4px 16px rgba(10, 16, 40, 1);
  /** Accent glow stacked on headings and links (text-shadow only). */
  --text-shadow-glow: rgba(0, 0, 0, 1);

  --success: #7ba38c;
  --warning: #c4a574;
  --error: #c47a7a;

  --grid-line: #1e3a8a40;
  --viewport-tint: #0a1028a6;

  --font-display: "Orbitron", system-ui, sans-serif;
  --font-mono: "Share Tech Mono", ui-monospace, "Cascadia Code", monospace;
  --font-sans: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;

  --chamfer: 10px;
  --space-xs: 0.25rem;
  --space-sm: 0.5rem;
  --space-md: 1rem;
  --space-lg: 1.5rem;
  --space-xl: 2rem;
  --space-2xl: 3rem;
  --space-3xl: 4rem;

  --header-h: 4.25rem;
  --content-max: 72rem;

  --scrollbar-size: 6px;
  --scrollbar-track: #0a1028;
  --scrollbar-thumb: #4b6fd4;
  --scrollbar-thumb-hover: #6b8fe8;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  overflow-y: scroll;
}

body {
  margin: 0;
  min-height: 100vh;
  font-family: var(--font-sans);
  color: var(--text);
  background: var(--bg-deep);
  line-height: 1.6;
  overflow-x: hidden;
}

a {
  color: var(--accent);
  text-decoration: none;
  transition: color 0.2s ease, text-shadow 0.2s ease;
}

a:hover {
  color: var(--accent-hover);
  text-shadow: var(--text-shadow-readability), 0 0 24px var(--text-shadow-glow);
}

button {
  font-family: inherit;
  cursor: pointer;
}

#omosuen-viewport {
  position: fixed !important;
  inset: 0 !important;
  z-index: 0 !important;
  pointer-events: none;
}

/* ── Retro-futurist atmosphere ── */

.site-shell {
  position: relative;
  z-index: 1;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  text-shadow: var(--text-shadow-readability);
}

.site-shell::before {
  content: "";
  position: fixed;
  inset: 0;
  z-index: -2;
  pointer-events: none;
  opacity: 0.35;
  background-image:
    linear-gradient(var(--grid-line) 1px, transparent 1px),
    linear-gradient(90deg, var(--grid-line) 1px, transparent 1px);
  background-size: 40px 40px;
  mask-image: radial-gradient(ellipse 80% 70% at 50% 45%, black 20%, transparent 75%);
}

.site-shell::after {
  content: "";
  position: fixed;
  inset: 0;
  z-index: 9999;
  pointer-events: none;
  opacity: 0.18;
  background: repeating-linear-gradient(
    0deg,
    transparent,
    transparent 2px,
    rgba(0, 0, 0, 0.14) 2px,
    rgba(0, 0, 0, 0.14) 4px
  );
}

/* ── HUD panel (chamfered frame + corner ticks) ── */

.hud-panel {
  position: relative;
  background: var(--viewport-tint);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid var(--accent-soft);
  clip-path: polygon(
    var(--chamfer) 0,
    calc(100% - var(--chamfer)) 0,
    100% var(--chamfer),
    100% calc(100% - var(--chamfer)),
    calc(100% - var(--chamfer)) 100%,
    var(--chamfer) 100%,
    0 calc(100% - var(--chamfer)),
    0 var(--chamfer)
  );
  box-shadow:
    0 0 0 1px rgba(244, 233, 216, 0.04) inset,
    0 0 32px var(--glow-soft);
}

.hud-panel::before,
.hud-panel::after {
  content: "";
  position: absolute;
  width: 18px;
  height: 18px;
  border-color: var(--accent);
  border-style: solid;
  pointer-events: none;
  opacity: 0.85;
}

.hud-panel::before {
  top: 10px;
  left: 10px;
  border-width: 2px 0 0 2px;
}

.hud-panel::after {
  bottom: 10px;
  right: 10px;
  border-width: 0 2px 2px 0;
}

.hud-label {
  font-family: var(--font-mono);
  font-size: 0.75rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--accent-hover);
  text-shadow: var(--text-shadow-readability), 0 0 32px var(--text-shadow-glow);
}

.hud-tag {
  display: inline-block;
  font-family: var(--font-mono);
  font-size: 0.65rem;
  letter-spacing: 0.12em;
  padding: 0.1em 0.45em;
  margin-right: 0.35em;
  border: 1px solid var(--accent-soft);
  color: var(--accent-hover);
  vertical-align: middle;
}

/* ── Section headings ── */

.section-heading {
  display: flex;
  align-items: center;
  gap: var(--space-md);
  margin: 0 0 var(--space-xl);
  font-family: var(--font-display);
  font-size: 1.125rem;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.section-heading__index {
  font-family: var(--font-mono);
  font-size: 0.875rem;
  font-weight: 400;
  color: var(--accent);
  text-shadow: var(--text-shadow-readability), 0 0 24px var(--text-shadow-glow);
}

.section-heading__rule {
  flex: 1;
  height: 1px;
  background: linear-gradient(90deg, var(--accent-soft), transparent);
  box-shadow: 0 0 8px var(--glow-soft);
}

.section-heading__text {
  color: var(--parchment);
  text-shadow: var(--text-shadow-readability), 0 0 40px var(--text-shadow-glow);
}

.section-heading--center {
  justify-content: center;
  gap: var(--space-sm);
}

.section-heading--center .section-heading__index::after {
  content: "//";
  margin-left: 0.35em;
  color: var(--accent-soft);
}

/* ── Header ── */

.site-header {
  position: sticky;
  top: 0;
  z-index: 10;
  height: var(--header-h);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 var(--space-lg);
  background: linear-gradient(180deg, rgba(10, 16, 40, 0.97) 0%, rgba(10, 16, 40, 0.82) 100%);
  border-bottom: 1px solid var(--accent-soft);
  box-shadow: 0 1px 24px var(--glow-soft);
}

.site-header__brand {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  filter: drop-shadow(0 0 8px var(--glow-soft));
}

.site-header__logo {
  height: 2rem;
  width: auto;
}

.site-header__nav {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

.site-header__link {
  font-family: var(--font-mono);
  font-size: 0.8125rem;
  font-weight: 400;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--text-muted);
  padding: var(--space-xs) var(--space-sm);
  border: 1px solid transparent;
  transition: color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
}

.site-header__link:hover {
  color: var(--accent-hover);
  border-color: var(--accent-soft);
  box-shadow: 0 0 12px var(--glow-soft);
  background: transparent;
}

.site-header__link--active {
  color: var(--accent-hover);
  border-color: var(--accent-soft);
  box-shadow: 0 0 12px var(--glow-soft);
}

.site-header__link--cta {
  color: var(--text-on-lapis);
  background: var(--lapis);
  border: 1px solid var(--accent);
  padding: var(--space-sm) var(--space-md);
  clip-path: polygon(
    6px 0,
    calc(100% - 6px) 0,
    100% 6px,
    100% calc(100% - 6px),
    calc(100% - 6px) 100%,
    6px 100%,
    0 calc(100% - 6px),
    0 6px
  );
  box-shadow: 0 0 16px var(--glow-soft);
}

.site-header__link--cta:hover {
  background: var(--accent);
  color: var(--text-on-lapis);
  box-shadow: 0 0 24px var(--glow);
}

/* ── Main ── */

.site-main {
  flex: 1;
  width: 100%;
  max-width: var(--content-max);
  margin: 0 auto;
  padding: 0 var(--space-lg) var(--space-3xl);
}

.site-main > section + section {
  margin-top: var(--space-2xl);
}

.site-shell:has(.docs-page--with-sidebar) {
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
}

/* Docs: full-width shell so the sidebar can sit on the viewport edge. */
.site-main:has(.docs-page--with-sidebar) {
  max-width: none;
  width: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

/* ── Hero ── */

.landing-hero {
  padding: var(--space-2xl) 0 var(--space-3xl);
  min-height: calc(100vh - var(--header-h) - 4rem);
  display: flex;
  align-items: center;
}

.landing-hero__content {
  max-width: 42rem;
  padding: var(--space-xl) var(--space-xl) var(--space-lg);
}

.landing-hero__eyebrow {
  display: block;
  margin-bottom: var(--space-md);
}

.landing-hero__title {
  font-family: var(--font-display);
  font-size: clamp(2rem, 4.5vw, 3.25rem);
  font-weight: 800;
  line-height: 1.12;
  letter-spacing: 0.04em;
  margin: 0 0 var(--space-md);
  color: var(--parchment);
  text-shadow: var(--text-shadow-readability), 0 0 48px var(--text-shadow-glow);
}

.landing-hero__lead {
  font-size: 1.0625rem;
  color: var(--text-muted);
  max-width: 36rem;
  margin: 0 0 var(--space-xl);
}

.landing-hero__actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-md);
}

/* ── Buttons ── */

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-sm) var(--space-lg);
  font-family: var(--font-mono);
  font-size: 0.8125rem;
  font-weight: 400;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  border: 1px solid var(--accent-soft);
  clip-path: polygon(
    6px 0,
    calc(100% - 6px) 0,
    100% 6px,
    100% calc(100% - 6px),
    calc(100% - 6px) 100%,
    6px 100%,
    0 calc(100% - 6px),
    0 6px
  );
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
}

.btn--primary {
  background: var(--lapis);
  color: var(--text-on-lapis);
  border-color: var(--accent);
  box-shadow: 0 0 20px var(--glow-soft);
}

.btn--primary:hover {
  background: var(--accent);
  box-shadow: 0 0 28px var(--glow);
}

.btn--secondary {
  background: rgba(10, 16, 40, 0.45);
  color: var(--text);
}

.btn--secondary:hover {
  border-color: var(--accent-hover);
  color: var(--accent-hover);
  box-shadow: 0 0 16px var(--glow-soft);
}

/* ── Features ── */

.landing-features {
  padding: var(--space-2xl) 0;
}

.landing-features__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: var(--space-lg);
}

.hud-card {
  padding: var(--space-lg);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.hud-card:hover {
  border-color: var(--accent);
  box-shadow: 0 0 28px var(--glow-soft);
  transform: translateY(-2px);
}

.feature-card__index {
  display: block;
  font-family: var(--font-mono);
  font-size: 0.75rem;
  letter-spacing: 0.14em;
  color: var(--accent);
  margin-bottom: var(--space-sm);
  text-shadow: var(--text-shadow-readability), 0 0 20px var(--text-shadow-glow);
}

.feature-card__title {
  font-family: var(--font-display);
  font-size: 0.9375rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin: 0 0 var(--space-sm);
  color: var(--parchment);
}

.feature-card__text {
  font-size: 0.9375rem;
  color: var(--text-muted);
  margin: 0;
  line-height: 1.55;
}

/* ── Quick start / terminal ── */

.landing-quickstart {
  padding: var(--space-2xl) 0;
}

.landing-quickstart__lead {
  color: var(--text-muted);
  margin: 0 0 var(--space-lg);
  max-width: 40rem;
}

.terminal {
  overflow: hidden;
}

.terminal__bar {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.45rem 0.75rem;
  background: rgba(10, 16, 40, 0.85);
  border-bottom: 1px solid var(--accent-soft);
}

.terminal__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--accent-soft);
  box-shadow: 0 0 6px var(--glow-soft);
}

.terminal__dot:first-child {
  background: var(--accent);
}

.terminal__label {
  margin-left: auto;
  font-family: var(--font-mono);
  font-size: 0.6875rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.code-block {
  background: rgba(10, 16, 40, 0.75);
  border: none;
  border-radius: 0;
  padding: var(--space-lg);
  margin: 0;
  overflow-x: auto;
  font-family: var(--font-mono);
  font-size: 0.8125rem;
  line-height: 1.75;
  color: var(--parchment);
  text-shadow: none;
}

/* ── Docs ── */

.docs-page {
  padding: var(--space-lg) 0 var(--space-3xl);
}

.docs-page--with-sidebar {
  padding: 0;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.docs-layout {
  display: grid;
  grid-template-columns: 15rem minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr);
  gap: 0;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.docs-sidebar-shell {
  min-width: 0;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.docs-sidebar__toggle {
  display: none;
}

.docs-sidebar {
  padding: var(--space-md) 0 var(--space-lg);
  margin: 0;
  border-left: none;
  border-top: none;
  border-bottom: none;
  border-radius: 0;
  clip-path: polygon(
    0 0,
    calc(100% - var(--chamfer)) 0,
    100% var(--chamfer),
    100% calc(100% - var(--chamfer)),
    calc(100% - var(--chamfer)) 100%,
    0 100%
  );
}

.docs-sidebar::before,
.docs-sidebar::after {
  display: none;
}

.docs-sidebar__title {
  margin: 0 var(--space-md) var(--space-sm);
}

.docs-sidebar__title--plugins {
  margin-top: var(--space-lg);
  padding-top: var(--space-md);
  border-top: 1px solid var(--accent-soft);
}

.docs-plugin {
  margin-top: var(--space-2xl);
}

.docs-plugin__lead {
  margin: 0 0 var(--space-md);
  color: var(--text-muted);
  line-height: 1.6;
}

.docs-plugin__note {
  margin: 0 0 var(--space-md);
  color: var(--text-muted);
  line-height: 1.6;
}

.docs-plugin .terminal--inset {
  margin-bottom: var(--space-md);
}

.docs-plugin .terminal--inset:last-child {
  margin-bottom: 0;
}

.docs-sidebar__group {
  margin-top: var(--space-md);
  padding-top: var(--space-sm);
  border-top: 1px solid var(--accent-soft);
}

.docs-sidebar__heading {
  margin: 0 var(--space-md) var(--space-xs);
  font-family: var(--font-mono);
  font-size: 0.6875rem;
  font-weight: 400;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--accent-soft);
}

.docs-sidebar__nav {
  display: flex;
  flex-direction: column;
}

.docs-sidebar__nav--overview {
  margin: 0 0 var(--space-sm);
  padding-bottom: var(--space-sm);
  border-bottom: 1px solid var(--accent-soft);
}

.docs-sidebar__nav--base {
  margin-bottom: var(--space-xs);
}

.docs-sidebar__link {
  display: block;
  padding: 0.35rem var(--space-md);
  font-family: var(--font-mono);
  font-size: 0.8125rem;
  letter-spacing: 0.04em;
  color: var(--text-muted);
  text-decoration: none;
  border-left: 2px solid transparent;
  transition: color 0.15s ease, background 0.15s ease, border-color 0.15s ease;
}

.docs-sidebar__link:hover {
  color: var(--accent-hover);
  background: rgba(75, 111, 212, 0.08);
}

.docs-sidebar__link--active {
  color: var(--parchment);
  border-left-color: var(--accent);
  background: rgba(75, 111, 212, 0.12);
}

.docs-content {
  min-width: 0;
  min-height: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: var(--space-lg) var(--space-xl) var(--space-3xl);
  max-width: none;
}

.docs-scroll,
.docs-content,
.docs-sidebar-shell,
.docs-sidebar-shell--open .docs-sidebar {
  scrollbar-width: thin;
  scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);
}

.docs-scroll::-webkit-scrollbar,
.docs-content::-webkit-scrollbar,
.docs-sidebar-shell::-webkit-scrollbar,
.docs-sidebar-shell--open .docs-sidebar::-webkit-scrollbar {
  width: var(--scrollbar-size);
  height: var(--scrollbar-size);
}

.docs-scroll::-webkit-scrollbar-track,
.docs-content::-webkit-scrollbar-track,
.docs-sidebar-shell::-webkit-scrollbar-track,
.docs-sidebar-shell--open .docs-sidebar::-webkit-scrollbar-track {
  background: var(--scrollbar-track);
}

.docs-scroll::-webkit-scrollbar-thumb,
.docs-content::-webkit-scrollbar-thumb,
.docs-sidebar-shell::-webkit-scrollbar-thumb,
.docs-sidebar-shell--open .docs-sidebar::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb);
  border-radius: 999px;
  border: 1px solid var(--scrollbar-track);
}

.docs-scroll::-webkit-scrollbar-thumb:hover,
.docs-content::-webkit-scrollbar-thumb:hover,
.docs-sidebar-shell::-webkit-scrollbar-thumb:hover,
.docs-sidebar-shell--open .docs-sidebar::-webkit-scrollbar-thumb:hover {
  background: var(--scrollbar-thumb-hover);
}

.docs-content__header {
  margin-bottom: var(--space-xl);
}

.docs-component__meta {
  margin: 0 0 var(--space-sm);
}

.docs-stub__badge {
  margin: 0 0 var(--space-md);
}

.docs-stub__heading {
  font-family: var(--font-display);
  font-size: 0.875rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--parchment);
  margin: var(--space-lg) 0 var(--space-sm);
}

.docs-stub__heading:first-of-type {
  margin-top: 0;
}

.docs-stub__placeholder {
  margin: 0;
  font-family: var(--font-mono);
  font-size: 0.8125rem;
  color: var(--accent-soft);
  letter-spacing: 0.04em;
}

.docs-api {
  margin-top: var(--space-2xl);
}

.docs-api__lead {
  margin: 0 0 var(--space-md);
  color: var(--text-muted);
  line-height: 1.6;
}

.docs-api__note {
  margin: 0 0 var(--space-lg);
  padding: var(--space-md) var(--space-lg);
  background: rgba(10, 16, 40, 0.45);
  border: 1px solid var(--accent-soft);
  color: var(--text-muted);
  line-height: 1.6;
}

.docs-api__table-wrap {
  overflow-x: auto;
  padding: 0;
}

.docs-api__table-wrap.hud-panel {
  padding: var(--space-lg) var(--space-md) var(--space-md);
}

.docs-api__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.docs-api__table th {
  text-align: left;
  padding: var(--space-sm) var(--space-md);
  font-family: var(--font-mono);
  font-size: 0.6875rem;
  font-weight: 400;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--accent-soft);
  border-bottom: 1px solid var(--accent-soft);
  background: rgba(10, 16, 40, 0.55);
}

.docs-api__table td {
  padding: var(--space-sm) var(--space-md);
  vertical-align: top;
  border-bottom: 1px solid rgba(46, 74, 158, 0.35);
  line-height: 1.5;
}

.docs-api__table tbody tr:last-child td {
  border-bottom: none;
}

.docs-api__key,
.docs-api__arg-name {
  font-family: var(--font-mono);
  font-size: 0.8125rem;
  color: var(--text);
}

.docs-api__type,
.docs-api__arg-type {
  font-family: var(--font-mono);
  font-size: 0.8125rem;
  white-space: nowrap;
  color: var(--accent-hover);
}

.docs-api__desc {
  color: var(--text-muted);
}

.docs-api__empty {
  color: var(--accent-soft);
  font-style: italic;
}

.docs-api__method-row td {
  background: rgba(10, 16, 40, 0.5);
  border-bottom: 1px solid rgba(46, 74, 158, 0.35);
}

.docs-api__method-row:has(+ .docs-api__arg-row) td {
  border-bottom: none;
}

.docs-api__arg-row td {
  background: rgba(30, 58, 138, 0.22);
  border-bottom: 1px solid rgba(46, 74, 158, 0.18);
  font-size: 0.8125rem;
  color: var(--text-muted);
}

.docs-api__arg-row:has(+ .docs-api__method-row) td,
.docs-api__arg-row:last-child td,
.docs-api__method-row:not(:has(+ .docs-api__arg-row)) td {
  border-bottom: 1px solid rgba(46, 74, 158, 0.35);
}

.docs-api__arg-row .docs-api__arg-name {
  padding-left: calc(var(--space-md) + 1.25rem);
  position: relative;
}

.docs-api__method-row + .docs-api__arg-row .docs-api__arg-name::before,
.docs-api__arg-row + .docs-api__arg-row .docs-api__arg-name::before {
  content: "↳";
  position: absolute;
  left: var(--space-md);
  color: var(--accent-soft);
  font-family: var(--font-mono);
  font-size: 0.75rem;
}

.docs-api__arg-type {
  font-size: 0.75rem;
}

.docs-api__arg-desc {
  color: var(--text-muted);
}

.docs-hero {
  padding: var(--space-xl) 0 var(--space-2xl);
}

.docs-hero__content {
  max-width: 44rem;
  padding: var(--space-xl);
}

.docs-hero__eyebrow {
  display: block;
  margin-bottom: var(--space-md);
}

.docs-hero__title {
  font-family: var(--font-display);
  font-size: clamp(1.75rem, 3.5vw, 2.5rem);
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: 0.04em;
  margin: 0 0 var(--space-md);
  color: var(--parchment);
  text-shadow: var(--text-shadow-readability), 0 0 48px var(--text-shadow-glow);
}

.docs-hero__lead {
  font-size: 1.0625rem;
  color: var(--text-muted);
  margin: 0;
  max-width: 40rem;
  line-height: 1.6;
}

.docs-hero__lead a {
  color: var(--accent-hover);
}

.docs-section {
  margin-top: var(--space-2xl);
}

.docs-section--cta {
  margin-top: var(--space-3xl);
}

.docs-prose {
  padding: var(--space-lg) var(--space-xl);
  color: var(--text-muted);
  line-height: 1.65;
}

.docs-prose p {
  margin: 0 0 var(--space-md);
}

.docs-prose p:last-child {
  margin-bottom: 0;
}

.docs-prose strong {
  color: var(--parchment);
  font-weight: 600;
}

.docs-prose code {
  font-family: var(--font-mono);
  font-size: 0.875em;
  color: var(--accent-hover);
  background: rgba(10, 16, 40, 0.55);
  padding: 0.1em 0.35em;
  border: 1px solid var(--accent-soft);
}

/* Inline-code chrome fragments across wrapped lines inside pre — strip it for blocks. */
.docs-prose pre code,
.code-block code {
  display: block;
  background: none;
  padding: 0;
  border: none;
  font-size: inherit;
  color: inherit;
  text-shadow: none;
}

.docs-list {
  list-style: none;
  margin: 0 0 var(--space-lg);
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
}

.docs-list li {
  padding-left: 0;
  line-height: 1.55;
}

.docs-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: var(--space-lg);
}

.docs-card {
  min-height: 100%;
}

.terminal--inset {
  margin: var(--space-md) 0;
}

.docs-cta {
  padding: var(--space-xl);
  text-align: center;
  max-width: 36rem;
  margin: 0 auto;
}

.docs-cta__text {
  color: var(--text-muted);
  margin: 0 0 var(--space-lg);
  line-height: 1.6;
}

.docs-cta .landing-hero__actions {
  justify-content: center;
}

/* ── Demo (Textris) ──
   The game canvas is a fixed, centred element the engine appends to the body,
   so this chrome floats over it as a left rail rather than flowing in the
   document. The canvas container is inset clear of the header (and, at the
   narrow breakpoint, of the controls strip) so the board art is never hidden
   behind either — the scene fits the canvas to this box, not to the window. */

#textris-viewport {
  top: var(--header-h) !important;
  bottom: 0 !important;
}

.site-main:has(.demo-page) {
  max-width: none;
  width: 100%;
  margin: 0;
  padding: 0;
}

.demo-page {
  position: fixed;
  left: var(--space-lg);
  top: calc(var(--header-h) + var(--space-md));
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
  width: min(23rem, 30vw);
  max-height: calc(100vh - var(--header-h) - var(--space-2xl));
  overflow-y: auto;
}

.demo-page__panel {
  padding: var(--space-lg);
}

.demo-page__eyebrow {
  display: block;
  margin-bottom: var(--space-sm);
}

.demo-page__title {
  font-family: var(--font-display);
  font-size: 1.75rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  margin: 0 0 var(--space-sm);
  color: var(--parchment);
  text-shadow: var(--text-shadow-readability), 0 0 48px var(--text-shadow-glow);
}

.demo-page__lead {
  font-size: 0.875rem;
  line-height: 1.6;
  color: var(--text-muted);
  margin: 0 0 var(--space-lg);
}

.demo-legend {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: var(--space-xs);
}

.demo-legend__item {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  font-family: var(--font-mono);
  font-size: 0.75rem;
  color: var(--text-muted);
}

.demo-legend__key {
  flex: 0 0 4.5rem;
  text-align: center;
  font-family: var(--font-mono);
  font-size: 0.75rem;
  padding: 0.15em 0.4em;
  border: 1px solid var(--accent-soft);
  border-radius: 3px;
  background: var(--bg-raised);
  color: var(--parchment);
}

.demo-page__note {
  margin: var(--space-lg) 0 0;
  font-family: var(--font-mono);
  font-size: 0.7rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--accent-hover);
}

.demo-page__credit {
  margin: 0;
  font-family: var(--font-mono);
  font-size: 0.6875rem;
  line-height: 1.5;
  color: var(--text-muted);
  opacity: 0.75;
}

/* Below this the canvas is wide enough to reach the rail, so the chrome drops
   to a single translucent strip along the bottom and sheds its long copy. */
@media (max-width: 1180px) {
  /* Keep the board clear of the controls strip this breakpoint drops in. */
  #textris-viewport {
    bottom: 7rem !important;
  }

  .demo-page {
    left: 0;
    right: 0;
    top: auto;
    bottom: 0;
    width: 100%;
    max-height: none;
    padding: var(--space-sm) var(--space-md);
    background: var(--viewport-tint);
    backdrop-filter: blur(2px);
  }

  .demo-page__panel {
    padding: var(--space-sm) var(--space-md);
    background: transparent;
    border: 0;
    box-shadow: none;
    clip-path: none;
  }

  .demo-page__eyebrow,
  .demo-page__lead,
  .demo-page__credit {
    display: none;
  }

  .demo-page__title {
    font-size: 1.125rem;
    margin: 0;
  }

  .demo-legend {
    grid-auto-flow: column;
    grid-auto-columns: max-content;
    justify-content: start;
    gap: var(--space-md);
    margin-top: var(--space-xs);
  }

  .demo-page__note {
    display: none;
  }
}

@media (max-width: 768px) {
  .docs-layout {
    grid-template-columns: 1fr;
    grid-template-rows: auto minmax(0, 1fr);
  }

  .docs-sidebar-shell {
    z-index: 20;
    flex-shrink: 0;
    overflow: visible;
    background: var(--bg-deep);
    border-bottom: 1px solid var(--accent-soft);
  }

  .docs-sidebar__toggle {
    display: flex;
    align-items: center;
    gap: var(--space-sm);
    width: 100%;
    margin: 0;
    padding: var(--space-sm) var(--space-md);
    border: none;
    border-radius: 0;
    clip-path: none;
    text-align: left;
    box-shadow: none;
  }

  .docs-sidebar__toggle-label {
    font-family: var(--font-mono);
    font-size: 0.6875rem;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: var(--accent-soft);
    flex-shrink: 0;
  }

  .docs-sidebar__toggle-current {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: var(--parchment);
  }

  .docs-sidebar__toggle-icon {
    flex-shrink: 0;
    font-size: 0.625rem;
    color: var(--accent-hover);
  }

  .docs-sidebar-shell:not(.docs-sidebar-shell--open) .docs-sidebar {
    display: none;
  }

  .docs-sidebar-shell--open .docs-sidebar {
    display: block;
    position: static;
    max-height: min(70vh, 28rem);
    overflow-y: auto;
    overscroll-behavior: contain;
    border-right: none;
    border-bottom: none;
    clip-path: none;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
  }

  .docs-content {
    padding: var(--space-md) var(--space-md) var(--space-2xl);
  }
}

/* ── Footer ── */

.site-footer {
  position: relative;
  padding: var(--space-xl) var(--space-lg);
  background: linear-gradient(0deg, var(--bg-deep) 0%, rgba(10, 16, 40, 0.92) 100%);
  text-align: center;
}

.site-footer__rule {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    var(--accent) 20%,
    var(--accent-hover) 50%,
    var(--accent) 80%,
    transparent
  );
  box-shadow: 0 0 12px var(--glow);
}

.site-footer__inner {
  max-width: var(--content-max);
  margin: 0 auto;
}

.site-footer__logo {
  height: 1.5rem;
  width: auto;
  opacity: 0.9;
  margin-bottom: var(--space-md);
  filter: drop-shadow(0 0 8px var(--glow-soft));
}

.site-footer__list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.site-footer__item {
  font-family: var(--font-mono);
  font-size: 0.75rem;
  letter-spacing: 0.04em;
  color: var(--text-muted);
}

.site-footer__item + .site-footer__item {
  margin-top: var(--space-xs);
}

.site-footer__item a {
  color: var(--text-muted);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.site-footer__item a:hover {
  color: var(--accent-hover);
}

.site-footer__version {
  margin-top: var(--space-md);
  font-family: var(--font-mono);
  font-size: 0.75rem;
  letter-spacing: 0.1em;
  color: var(--accent-soft);
}

@media (max-width: 640px) {
  .site-header__nav {
    gap: 0.15rem;
  }

  .site-header__link {
    font-size: 0.6875rem;
    padding: var(--space-xs);
  }

  .section-heading {
    flex-wrap: wrap;
    letter-spacing: 0.12em;
  }
}

@media (prefers-reduced-motion: reduce) {
  .hud-card:hover {
    transform: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAEA;EACE,gBAAgB;EAChB,oBAAoB;;EAEpB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;;EAEnB,eAAe;EACf,qBAAqB;EACrB,wBAAwB;;EAExB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,iCAAiC;EACjC,qCAAqC;EACrC,8EAA8E;EAC9E;;kCAEgC;EAChC,mEAAmE;EACnE,oCAAoC;;EAEpC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;;EAEhB,sBAAsB;EACtB,0BAA0B;;EAE1B,iDAAiD;EACjD,wEAAwE;EACxE,qEAAqE;;EAErE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;;EAEjB,mBAAmB;EACnB,oBAAoB;;EAEpB,qBAAqB;EACrB,0BAA0B;EAC1B,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,0BAA0B;EAC1B,6EAA6E;AAC/E;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA,oCAAoC;;AAEpC;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb;;iEAE+D;EAC/D,0BAA0B;EAC1B,mFAAmF;AACrF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,aAAa;EACb,oBAAoB;EACpB,aAAa;EACb;;;;;;GAMC;AACH;;AAEA,qDAAqD;;AAErD;EACE,kBAAkB;EAClB,gCAAgC;EAChC,2BAA2B;EAC3B,mCAAmC;EACnC,oCAAoC;EACpC;;;;;;;;;GASC;EACD;;6BAE2B;AAC7B;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,6EAA6E;AAC/E;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,oCAAoC;EACpC,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA,2BAA2B;;AAE3B;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,2BAA2B;EAC3B,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,6EAA6E;AAC/E;;AAEA;EACE,OAAO;EACP,WAAW;EACX,mEAAmE;EACnE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,6EAA6E;AAC/E;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,iBAAiB;;AAEjB;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,2FAA2F;EAC3F,2CAA2C;EAC3C,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;EACxB,wCAAwC;EACxC,6BAA6B;EAC7B,yEAAyE;AAC3E;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,+BAA+B;EAC/B,wCAAwC;EACxC;;;;;;;;;GASC;EACD,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA,eAAe;;AAEf;EACE,OAAO;EACP,WAAW;EACX,6BAA6B;EAC7B,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,wEAAwE;AACxE;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA,eAAe;;AAEf;EACE,4CAA4C;EAC5C,gDAAgD;EAChD,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;EACtC,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,6EAA6E;AAC/E;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;;AAEA,kBAAkB;;AAElB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;EACpC;;;;;;;;;GASC;EACD,+FAA+F;AACjG;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA,mBAAmB;;AAEnB;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,6EAA6E;AAC/E;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,8BAA8B;EAC9B,6EAA6E;AAC/E;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,SAAS;EACT,iBAAiB;AACnB;;AAEA,iCAAiC;;AAEjC;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,oBAAoB;EACpB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,oBAAoB;EACpB,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,eAAe;;AAEf;EACE,2CAA2C;AAC7C;;AAEA;EACE,UAAU;EACV,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,kCAAkC;EAClC,MAAM;EACN,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB;;;;;;;GAOC;AACH;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;EACzC,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,6BAA6B;EAC7B,oBAAoB;EACpB,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,kCAAkC;EAClC,4EAA4E;AAC9E;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,yDAAyD;EACzD,eAAe;AACjB;;AAEA;;;;EAIE,qBAAqB;EACrB,8DAA8D;AAChE;;AAEA;;;;EAIE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;;;EAIE,kCAAkC;AACpC;;AAEA;;;;EAIE,kCAAkC;EAClC,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;;;;EAIE,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,kCAAkC;EAClC,oCAAoC;EACpC,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;EAEE,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,gDAAgD;EAChD,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;;;EAGE,gDAAgD;AAClD;;AAEA;EACE,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,6EAA6E;AAC/E;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,0BAA0B;EAC1B,kCAAkC;EAClC,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,wFAAwF;AACxF;;EAEE,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;;;8EAK8E;;AAE9E;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,4CAA4C;EAC5C,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,4DAA4D;EAC5D,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,6EAA6E;AAC/E;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;EAClB,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;AACf;;AAEA;4EAC4E;AAC5E;EACE,yEAAyE;EACzE;IACE,uBAAuB;EACzB;;EAEA;IACE,OAAO;IACP,QAAQ;IACR,SAAS;IACT,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,wCAAwC;IACxC,gCAAgC;IAChC,0BAA0B;EAC5B;;EAEA;IACE,wCAAwC;IACxC,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,8BAA8B;IAC9B,sBAAsB;IACtB,oBAAoB;IACpB,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,uCAAuC;EACzC;;EAEA;IACE,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,0BAA0B;IAC1B,2CAA2C;EAC7C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;IACX,SAAS;IACT,wCAAwC;IACxC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;IAC7B,oBAAoB;IACpB,sBAAsB;IACtB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,OAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,4BAA4B;IAC5B,gBAAgB;IAChB,4BAA4B;IAC5B,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,0CAA0C;EAC5C;;EAEA;IACE,yDAAyD;EAC3D;AACF;;AAEA,iBAAiB;;AAEjB;EACE,kBAAkB;EAClB,wCAAwC;EACxC,iFAAiF;EACjF,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX;;;;;;;GAOC;EACD,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["@import \"./highlight.css\";\n\n:root {\n  --lapis: #1e3a8a;\n  --parchment: #f4e9d8;\n\n  --bg-deep: #0a1028;\n  --bg-panel: #101b3d;\n  --bg-raised: #152352;\n  --bg-lapis: #1e3a8a;\n\n  --text: #f4e9d8;\n  --text-muted: #b8aa96;\n  --text-on-lapis: #f4e9d8;\n\n  --accent: #4b6fd4;\n  --accent-hover: #6b8fe8;\n  --accent-soft: #2e4a9e;\n  --glow: rgba(107, 143, 232, 0.55);\n  --glow-soft: rgba(75, 111, 212, 0.25);\n  /** Dark halo so type stays legible over bright 3D cells behind the overlay. */\n  --text-shadow-readability:\n    0 2px 4px rgba(10, 16, 40, 1),\n    0 4px 16px rgba(10, 16, 40, 1);\n  /** Accent glow stacked on headings and links (text-shadow only). */\n  --text-shadow-glow: rgba(0, 0, 0, 1);\n\n  --success: #7ba38c;\n  --warning: #c4a574;\n  --error: #c47a7a;\n\n  --grid-line: #1e3a8a40;\n  --viewport-tint: #0a1028a6;\n\n  --font-display: \"Orbitron\", system-ui, sans-serif;\n  --font-mono: \"Share Tech Mono\", ui-monospace, \"Cascadia Code\", monospace;\n  --font-sans: system-ui, -apple-system, \"Segoe UI\", Roboto, sans-serif;\n\n  --chamfer: 10px;\n  --space-xs: 0.25rem;\n  --space-sm: 0.5rem;\n  --space-md: 1rem;\n  --space-lg: 1.5rem;\n  --space-xl: 2rem;\n  --space-2xl: 3rem;\n  --space-3xl: 4rem;\n\n  --header-h: 4.25rem;\n  --content-max: 72rem;\n\n  --scrollbar-size: 6px;\n  --scrollbar-track: #0a1028;\n  --scrollbar-thumb: #4b6fd4;\n  --scrollbar-thumb-hover: #6b8fe8;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nhtml {\n  font-size: 16px;\n  -webkit-font-smoothing: antialiased;\n  overflow-y: scroll;\n}\n\nbody {\n  margin: 0;\n  min-height: 100vh;\n  font-family: var(--font-sans);\n  color: var(--text);\n  background: var(--bg-deep);\n  line-height: 1.6;\n  overflow-x: hidden;\n}\n\na {\n  color: var(--accent);\n  text-decoration: none;\n  transition: color 0.2s ease, text-shadow 0.2s ease;\n}\n\na:hover {\n  color: var(--accent-hover);\n  text-shadow: var(--text-shadow-readability), 0 0 24px var(--text-shadow-glow);\n}\n\nbutton {\n  font-family: inherit;\n  cursor: pointer;\n}\n\n#omosuen-viewport {\n  position: fixed !important;\n  inset: 0 !important;\n  z-index: 0 !important;\n  pointer-events: none;\n}\n\n/* ── Retro-futurist atmosphere ── */\n\n.site-shell {\n  position: relative;\n  z-index: 1;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  text-shadow: var(--text-shadow-readability);\n}\n\n.site-shell::before {\n  content: \"\";\n  position: fixed;\n  inset: 0;\n  z-index: -2;\n  pointer-events: none;\n  opacity: 0.35;\n  background-image:\n    linear-gradient(var(--grid-line) 1px, transparent 1px),\n    linear-gradient(90deg, var(--grid-line) 1px, transparent 1px);\n  background-size: 40px 40px;\n  mask-image: radial-gradient(ellipse 80% 70% at 50% 45%, black 20%, transparent 75%);\n}\n\n.site-shell::after {\n  content: \"\";\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  pointer-events: none;\n  opacity: 0.18;\n  background: repeating-linear-gradient(\n    0deg,\n    transparent,\n    transparent 2px,\n    rgba(0, 0, 0, 0.14) 2px,\n    rgba(0, 0, 0, 0.14) 4px\n  );\n}\n\n/* ── HUD panel (chamfered frame + corner ticks) ── */\n\n.hud-panel {\n  position: relative;\n  background: var(--viewport-tint);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid var(--accent-soft);\n  clip-path: polygon(\n    var(--chamfer) 0,\n    calc(100% - var(--chamfer)) 0,\n    100% var(--chamfer),\n    100% calc(100% - var(--chamfer)),\n    calc(100% - var(--chamfer)) 100%,\n    var(--chamfer) 100%,\n    0 calc(100% - var(--chamfer)),\n    0 var(--chamfer)\n  );\n  box-shadow:\n    0 0 0 1px rgba(244, 233, 216, 0.04) inset,\n    0 0 32px var(--glow-soft);\n}\n\n.hud-panel::before,\n.hud-panel::after {\n  content: \"\";\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  border-color: var(--accent);\n  border-style: solid;\n  pointer-events: none;\n  opacity: 0.85;\n}\n\n.hud-panel::before {\n  top: 10px;\n  left: 10px;\n  border-width: 2px 0 0 2px;\n}\n\n.hud-panel::after {\n  bottom: 10px;\n  right: 10px;\n  border-width: 0 2px 2px 0;\n}\n\n.hud-label {\n  font-family: var(--font-mono);\n  font-size: 0.75rem;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--accent-hover);\n  text-shadow: var(--text-shadow-readability), 0 0 32px var(--text-shadow-glow);\n}\n\n.hud-tag {\n  display: inline-block;\n  font-family: var(--font-mono);\n  font-size: 0.65rem;\n  letter-spacing: 0.12em;\n  padding: 0.1em 0.45em;\n  margin-right: 0.35em;\n  border: 1px solid var(--accent-soft);\n  color: var(--accent-hover);\n  vertical-align: middle;\n}\n\n/* ── Section headings ── */\n\n.section-heading {\n  display: flex;\n  align-items: center;\n  gap: var(--space-md);\n  margin: 0 0 var(--space-xl);\n  font-family: var(--font-display);\n  font-size: 1.125rem;\n  font-weight: 700;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n}\n\n.section-heading__index {\n  font-family: var(--font-mono);\n  font-size: 0.875rem;\n  font-weight: 400;\n  color: var(--accent);\n  text-shadow: var(--text-shadow-readability), 0 0 24px var(--text-shadow-glow);\n}\n\n.section-heading__rule {\n  flex: 1;\n  height: 1px;\n  background: linear-gradient(90deg, var(--accent-soft), transparent);\n  box-shadow: 0 0 8px var(--glow-soft);\n}\n\n.section-heading__text {\n  color: var(--parchment);\n  text-shadow: var(--text-shadow-readability), 0 0 40px var(--text-shadow-glow);\n}\n\n.section-heading--center {\n  justify-content: center;\n  gap: var(--space-sm);\n}\n\n.section-heading--center .section-heading__index::after {\n  content: \"//\";\n  margin-left: 0.35em;\n  color: var(--accent-soft);\n}\n\n/* ── Header ── */\n\n.site-header {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  height: var(--header-h);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 var(--space-lg);\n  background: linear-gradient(180deg, rgba(10, 16, 40, 0.97) 0%, rgba(10, 16, 40, 0.82) 100%);\n  border-bottom: 1px solid var(--accent-soft);\n  box-shadow: 0 1px 24px var(--glow-soft);\n}\n\n.site-header__brand {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n  filter: drop-shadow(0 0 8px var(--glow-soft));\n}\n\n.site-header__logo {\n  height: 2rem;\n  width: auto;\n}\n\n.site-header__nav {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n}\n\n.site-header__link {\n  font-family: var(--font-mono);\n  font-size: 0.8125rem;\n  font-weight: 400;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  padding: var(--space-xs) var(--space-sm);\n  border: 1px solid transparent;\n  transition: color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.site-header__link:hover {\n  color: var(--accent-hover);\n  border-color: var(--accent-soft);\n  box-shadow: 0 0 12px var(--glow-soft);\n  background: transparent;\n}\n\n.site-header__link--active {\n  color: var(--accent-hover);\n  border-color: var(--accent-soft);\n  box-shadow: 0 0 12px var(--glow-soft);\n}\n\n.site-header__link--cta {\n  color: var(--text-on-lapis);\n  background: var(--lapis);\n  border: 1px solid var(--accent);\n  padding: var(--space-sm) var(--space-md);\n  clip-path: polygon(\n    6px 0,\n    calc(100% - 6px) 0,\n    100% 6px,\n    100% calc(100% - 6px),\n    calc(100% - 6px) 100%,\n    6px 100%,\n    0 calc(100% - 6px),\n    0 6px\n  );\n  box-shadow: 0 0 16px var(--glow-soft);\n}\n\n.site-header__link--cta:hover {\n  background: var(--accent);\n  color: var(--text-on-lapis);\n  box-shadow: 0 0 24px var(--glow);\n}\n\n/* ── Main ── */\n\n.site-main {\n  flex: 1;\n  width: 100%;\n  max-width: var(--content-max);\n  margin: 0 auto;\n  padding: 0 var(--space-lg) var(--space-3xl);\n}\n\n.site-main > section + section {\n  margin-top: var(--space-2xl);\n}\n\n.site-shell:has(.docs-page--with-sidebar) {\n  height: 100vh;\n  max-height: 100vh;\n  overflow: hidden;\n}\n\n/* Docs: full-width shell so the sidebar can sit on the viewport edge. */\n.site-main:has(.docs-page--with-sidebar) {\n  max-width: none;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n/* ── Hero ── */\n\n.landing-hero {\n  padding: var(--space-2xl) 0 var(--space-3xl);\n  min-height: calc(100vh - var(--header-h) - 4rem);\n  display: flex;\n  align-items: center;\n}\n\n.landing-hero__content {\n  max-width: 42rem;\n  padding: var(--space-xl) var(--space-xl) var(--space-lg);\n}\n\n.landing-hero__eyebrow {\n  display: block;\n  margin-bottom: var(--space-md);\n}\n\n.landing-hero__title {\n  font-family: var(--font-display);\n  font-size: clamp(2rem, 4.5vw, 3.25rem);\n  font-weight: 800;\n  line-height: 1.12;\n  letter-spacing: 0.04em;\n  margin: 0 0 var(--space-md);\n  color: var(--parchment);\n  text-shadow: var(--text-shadow-readability), 0 0 48px var(--text-shadow-glow);\n}\n\n.landing-hero__lead {\n  font-size: 1.0625rem;\n  color: var(--text-muted);\n  max-width: 36rem;\n  margin: 0 0 var(--space-xl);\n}\n\n.landing-hero__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-md);\n}\n\n/* ── Buttons ── */\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-sm) var(--space-lg);\n  font-family: var(--font-mono);\n  font-size: 0.8125rem;\n  font-weight: 400;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  border: 1px solid var(--accent-soft);\n  clip-path: polygon(\n    6px 0,\n    calc(100% - 6px) 0,\n    100% 6px,\n    100% calc(100% - 6px),\n    calc(100% - 6px) 100%,\n    6px 100%,\n    0 calc(100% - 6px),\n    0 6px\n  );\n  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.btn--primary {\n  background: var(--lapis);\n  color: var(--text-on-lapis);\n  border-color: var(--accent);\n  box-shadow: 0 0 20px var(--glow-soft);\n}\n\n.btn--primary:hover {\n  background: var(--accent);\n  box-shadow: 0 0 28px var(--glow);\n}\n\n.btn--secondary {\n  background: rgba(10, 16, 40, 0.45);\n  color: var(--text);\n}\n\n.btn--secondary:hover {\n  border-color: var(--accent-hover);\n  color: var(--accent-hover);\n  box-shadow: 0 0 16px var(--glow-soft);\n}\n\n/* ── Features ── */\n\n.landing-features {\n  padding: var(--space-2xl) 0;\n}\n\n.landing-features__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: var(--space-lg);\n}\n\n.hud-card {\n  padding: var(--space-lg);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;\n}\n\n.hud-card:hover {\n  border-color: var(--accent);\n  box-shadow: 0 0 28px var(--glow-soft);\n  transform: translateY(-2px);\n}\n\n.feature-card__index {\n  display: block;\n  font-family: var(--font-mono);\n  font-size: 0.75rem;\n  letter-spacing: 0.14em;\n  color: var(--accent);\n  margin-bottom: var(--space-sm);\n  text-shadow: var(--text-shadow-readability), 0 0 20px var(--text-shadow-glow);\n}\n\n.feature-card__title {\n  font-family: var(--font-display);\n  font-size: 0.9375rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  margin: 0 0 var(--space-sm);\n  color: var(--parchment);\n}\n\n.feature-card__text {\n  font-size: 0.9375rem;\n  color: var(--text-muted);\n  margin: 0;\n  line-height: 1.55;\n}\n\n/* ── Quick start / terminal ── */\n\n.landing-quickstart {\n  padding: var(--space-2xl) 0;\n}\n\n.landing-quickstart__lead {\n  color: var(--text-muted);\n  margin: 0 0 var(--space-lg);\n  max-width: 40rem;\n}\n\n.terminal {\n  overflow: hidden;\n}\n\n.terminal__bar {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.45rem 0.75rem;\n  background: rgba(10, 16, 40, 0.85);\n  border-bottom: 1px solid var(--accent-soft);\n}\n\n.terminal__dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--accent-soft);\n  box-shadow: 0 0 6px var(--glow-soft);\n}\n\n.terminal__dot:first-child {\n  background: var(--accent);\n}\n\n.terminal__label {\n  margin-left: auto;\n  font-family: var(--font-mono);\n  font-size: 0.6875rem;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n.code-block {\n  background: rgba(10, 16, 40, 0.75);\n  border: none;\n  border-radius: 0;\n  padding: var(--space-lg);\n  margin: 0;\n  overflow-x: auto;\n  font-family: var(--font-mono);\n  font-size: 0.8125rem;\n  line-height: 1.75;\n  color: var(--parchment);\n  text-shadow: none;\n}\n\n/* ── Docs ── */\n\n.docs-page {\n  padding: var(--space-lg) 0 var(--space-3xl);\n}\n\n.docs-page--with-sidebar {\n  padding: 0;\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.docs-layout {\n  display: grid;\n  grid-template-columns: 15rem minmax(0, 1fr);\n  grid-template-rows: minmax(0, 1fr);\n  gap: 0;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.docs-sidebar-shell {\n  min-width: 0;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n}\n\n.docs-sidebar__toggle {\n  display: none;\n}\n\n.docs-sidebar {\n  padding: var(--space-md) 0 var(--space-lg);\n  margin: 0;\n  border-left: none;\n  border-top: none;\n  border-bottom: none;\n  border-radius: 0;\n  clip-path: polygon(\n    0 0,\n    calc(100% - var(--chamfer)) 0,\n    100% var(--chamfer),\n    100% calc(100% - var(--chamfer)),\n    calc(100% - var(--chamfer)) 100%,\n    0 100%\n  );\n}\n\n.docs-sidebar::before,\n.docs-sidebar::after {\n  display: none;\n}\n\n.docs-sidebar__title {\n  margin: 0 var(--space-md) var(--space-sm);\n}\n\n.docs-sidebar__title--plugins {\n  margin-top: var(--space-lg);\n  padding-top: var(--space-md);\n  border-top: 1px solid var(--accent-soft);\n}\n\n.docs-plugin {\n  margin-top: var(--space-2xl);\n}\n\n.docs-plugin__lead {\n  margin: 0 0 var(--space-md);\n  color: var(--text-muted);\n  line-height: 1.6;\n}\n\n.docs-plugin__note {\n  margin: 0 0 var(--space-md);\n  color: var(--text-muted);\n  line-height: 1.6;\n}\n\n.docs-plugin .terminal--inset {\n  margin-bottom: var(--space-md);\n}\n\n.docs-plugin .terminal--inset:last-child {\n  margin-bottom: 0;\n}\n\n.docs-sidebar__group {\n  margin-top: var(--space-md);\n  padding-top: var(--space-sm);\n  border-top: 1px solid var(--accent-soft);\n}\n\n.docs-sidebar__heading {\n  margin: 0 var(--space-md) var(--space-xs);\n  font-family: var(--font-mono);\n  font-size: 0.6875rem;\n  font-weight: 400;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--accent-soft);\n}\n\n.docs-sidebar__nav {\n  display: flex;\n  flex-direction: column;\n}\n\n.docs-sidebar__nav--overview {\n  margin: 0 0 var(--space-sm);\n  padding-bottom: var(--space-sm);\n  border-bottom: 1px solid var(--accent-soft);\n}\n\n.docs-sidebar__nav--base {\n  margin-bottom: var(--space-xs);\n}\n\n.docs-sidebar__link {\n  display: block;\n  padding: 0.35rem var(--space-md);\n  font-family: var(--font-mono);\n  font-size: 0.8125rem;\n  letter-spacing: 0.04em;\n  color: var(--text-muted);\n  text-decoration: none;\n  border-left: 2px solid transparent;\n  transition: color 0.15s ease, background 0.15s ease, border-color 0.15s ease;\n}\n\n.docs-sidebar__link:hover {\n  color: var(--accent-hover);\n  background: rgba(75, 111, 212, 0.08);\n}\n\n.docs-sidebar__link--active {\n  color: var(--parchment);\n  border-left-color: var(--accent);\n  background: rgba(75, 111, 212, 0.12);\n}\n\n.docs-content {\n  min-width: 0;\n  min-height: 0;\n  width: 100%;\n  height: 100%;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  padding: var(--space-lg) var(--space-xl) var(--space-3xl);\n  max-width: none;\n}\n\n.docs-scroll,\n.docs-content,\n.docs-sidebar-shell,\n.docs-sidebar-shell--open .docs-sidebar {\n  scrollbar-width: thin;\n  scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);\n}\n\n.docs-scroll::-webkit-scrollbar,\n.docs-content::-webkit-scrollbar,\n.docs-sidebar-shell::-webkit-scrollbar,\n.docs-sidebar-shell--open .docs-sidebar::-webkit-scrollbar {\n  width: var(--scrollbar-size);\n  height: var(--scrollbar-size);\n}\n\n.docs-scroll::-webkit-scrollbar-track,\n.docs-content::-webkit-scrollbar-track,\n.docs-sidebar-shell::-webkit-scrollbar-track,\n.docs-sidebar-shell--open .docs-sidebar::-webkit-scrollbar-track {\n  background: var(--scrollbar-track);\n}\n\n.docs-scroll::-webkit-scrollbar-thumb,\n.docs-content::-webkit-scrollbar-thumb,\n.docs-sidebar-shell::-webkit-scrollbar-thumb,\n.docs-sidebar-shell--open .docs-sidebar::-webkit-scrollbar-thumb {\n  background: var(--scrollbar-thumb);\n  border-radius: 999px;\n  border: 1px solid var(--scrollbar-track);\n}\n\n.docs-scroll::-webkit-scrollbar-thumb:hover,\n.docs-content::-webkit-scrollbar-thumb:hover,\n.docs-sidebar-shell::-webkit-scrollbar-thumb:hover,\n.docs-sidebar-shell--open .docs-sidebar::-webkit-scrollbar-thumb:hover {\n  background: var(--scrollbar-thumb-hover);\n}\n\n.docs-content__header {\n  margin-bottom: var(--space-xl);\n}\n\n.docs-component__meta {\n  margin: 0 0 var(--space-sm);\n}\n\n.docs-stub__badge {\n  margin: 0 0 var(--space-md);\n}\n\n.docs-stub__heading {\n  font-family: var(--font-display);\n  font-size: 0.875rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--parchment);\n  margin: var(--space-lg) 0 var(--space-sm);\n}\n\n.docs-stub__heading:first-of-type {\n  margin-top: 0;\n}\n\n.docs-stub__placeholder {\n  margin: 0;\n  font-family: var(--font-mono);\n  font-size: 0.8125rem;\n  color: var(--accent-soft);\n  letter-spacing: 0.04em;\n}\n\n.docs-api {\n  margin-top: var(--space-2xl);\n}\n\n.docs-api__lead {\n  margin: 0 0 var(--space-md);\n  color: var(--text-muted);\n  line-height: 1.6;\n}\n\n.docs-api__note {\n  margin: 0 0 var(--space-lg);\n  padding: var(--space-md) var(--space-lg);\n  background: rgba(10, 16, 40, 0.45);\n  border: 1px solid var(--accent-soft);\n  color: var(--text-muted);\n  line-height: 1.6;\n}\n\n.docs-api__table-wrap {\n  overflow-x: auto;\n  padding: 0;\n}\n\n.docs-api__table-wrap.hud-panel {\n  padding: var(--space-lg) var(--space-md) var(--space-md);\n}\n\n.docs-api__table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.docs-api__table th {\n  text-align: left;\n  padding: var(--space-sm) var(--space-md);\n  font-family: var(--font-mono);\n  font-size: 0.6875rem;\n  font-weight: 400;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--accent-soft);\n  border-bottom: 1px solid var(--accent-soft);\n  background: rgba(10, 16, 40, 0.55);\n}\n\n.docs-api__table td {\n  padding: var(--space-sm) var(--space-md);\n  vertical-align: top;\n  border-bottom: 1px solid rgba(46, 74, 158, 0.35);\n  line-height: 1.5;\n}\n\n.docs-api__table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.docs-api__key,\n.docs-api__arg-name {\n  font-family: var(--font-mono);\n  font-size: 0.8125rem;\n  color: var(--text);\n}\n\n.docs-api__type,\n.docs-api__arg-type {\n  font-family: var(--font-mono);\n  font-size: 0.8125rem;\n  white-space: nowrap;\n  color: var(--accent-hover);\n}\n\n.docs-api__desc {\n  color: var(--text-muted);\n}\n\n.docs-api__empty {\n  color: var(--accent-soft);\n  font-style: italic;\n}\n\n.docs-api__method-row td {\n  background: rgba(10, 16, 40, 0.5);\n  border-bottom: 1px solid rgba(46, 74, 158, 0.35);\n}\n\n.docs-api__method-row:has(+ .docs-api__arg-row) td {\n  border-bottom: none;\n}\n\n.docs-api__arg-row td {\n  background: rgba(30, 58, 138, 0.22);\n  border-bottom: 1px solid rgba(46, 74, 158, 0.18);\n  font-size: 0.8125rem;\n  color: var(--text-muted);\n}\n\n.docs-api__arg-row:has(+ .docs-api__method-row) td,\n.docs-api__arg-row:last-child td,\n.docs-api__method-row:not(:has(+ .docs-api__arg-row)) td {\n  border-bottom: 1px solid rgba(46, 74, 158, 0.35);\n}\n\n.docs-api__arg-row .docs-api__arg-name {\n  padding-left: calc(var(--space-md) + 1.25rem);\n  position: relative;\n}\n\n.docs-api__method-row + .docs-api__arg-row .docs-api__arg-name::before,\n.docs-api__arg-row + .docs-api__arg-row .docs-api__arg-name::before {\n  content: \"↳\";\n  position: absolute;\n  left: var(--space-md);\n  color: var(--accent-soft);\n  font-family: var(--font-mono);\n  font-size: 0.75rem;\n}\n\n.docs-api__arg-type {\n  font-size: 0.75rem;\n}\n\n.docs-api__arg-desc {\n  color: var(--text-muted);\n}\n\n.docs-hero {\n  padding: var(--space-xl) 0 var(--space-2xl);\n}\n\n.docs-hero__content {\n  max-width: 44rem;\n  padding: var(--space-xl);\n}\n\n.docs-hero__eyebrow {\n  display: block;\n  margin-bottom: var(--space-md);\n}\n\n.docs-hero__title {\n  font-family: var(--font-display);\n  font-size: clamp(1.75rem, 3.5vw, 2.5rem);\n  font-weight: 800;\n  line-height: 1.15;\n  letter-spacing: 0.04em;\n  margin: 0 0 var(--space-md);\n  color: var(--parchment);\n  text-shadow: var(--text-shadow-readability), 0 0 48px var(--text-shadow-glow);\n}\n\n.docs-hero__lead {\n  font-size: 1.0625rem;\n  color: var(--text-muted);\n  margin: 0;\n  max-width: 40rem;\n  line-height: 1.6;\n}\n\n.docs-hero__lead a {\n  color: var(--accent-hover);\n}\n\n.docs-section {\n  margin-top: var(--space-2xl);\n}\n\n.docs-section--cta {\n  margin-top: var(--space-3xl);\n}\n\n.docs-prose {\n  padding: var(--space-lg) var(--space-xl);\n  color: var(--text-muted);\n  line-height: 1.65;\n}\n\n.docs-prose p {\n  margin: 0 0 var(--space-md);\n}\n\n.docs-prose p:last-child {\n  margin-bottom: 0;\n}\n\n.docs-prose strong {\n  color: var(--parchment);\n  font-weight: 600;\n}\n\n.docs-prose code {\n  font-family: var(--font-mono);\n  font-size: 0.875em;\n  color: var(--accent-hover);\n  background: rgba(10, 16, 40, 0.55);\n  padding: 0.1em 0.35em;\n  border: 1px solid var(--accent-soft);\n}\n\n/* Inline-code chrome fragments across wrapped lines inside pre — strip it for blocks. */\n.docs-prose pre code,\n.code-block code {\n  display: block;\n  background: none;\n  padding: 0;\n  border: none;\n  font-size: inherit;\n  color: inherit;\n  text-shadow: none;\n}\n\n.docs-list {\n  list-style: none;\n  margin: 0 0 var(--space-lg);\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-md);\n}\n\n.docs-list li {\n  padding-left: 0;\n  line-height: 1.55;\n}\n\n.docs-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: var(--space-lg);\n}\n\n.docs-card {\n  min-height: 100%;\n}\n\n.terminal--inset {\n  margin: var(--space-md) 0;\n}\n\n.docs-cta {\n  padding: var(--space-xl);\n  text-align: center;\n  max-width: 36rem;\n  margin: 0 auto;\n}\n\n.docs-cta__text {\n  color: var(--text-muted);\n  margin: 0 0 var(--space-lg);\n  line-height: 1.6;\n}\n\n.docs-cta .landing-hero__actions {\n  justify-content: center;\n}\n\n/* ── Demo (Textris) ──\n   The game canvas is a fixed, centred element the engine appends to the body,\n   so this chrome floats over it as a left rail rather than flowing in the\n   document. The canvas container is inset clear of the header (and, at the\n   narrow breakpoint, of the controls strip) so the board art is never hidden\n   behind either — the scene fits the canvas to this box, not to the window. */\n\n#textris-viewport {\n  top: var(--header-h) !important;\n  bottom: 0 !important;\n}\n\n.site-main:has(.demo-page) {\n  max-width: none;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n.demo-page {\n  position: fixed;\n  left: var(--space-lg);\n  top: calc(var(--header-h) + var(--space-md));\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-md);\n  width: min(23rem, 30vw);\n  max-height: calc(100vh - var(--header-h) - var(--space-2xl));\n  overflow-y: auto;\n}\n\n.demo-page__panel {\n  padding: var(--space-lg);\n}\n\n.demo-page__eyebrow {\n  display: block;\n  margin-bottom: var(--space-sm);\n}\n\n.demo-page__title {\n  font-family: var(--font-display);\n  font-size: 1.75rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  margin: 0 0 var(--space-sm);\n  color: var(--parchment);\n  text-shadow: var(--text-shadow-readability), 0 0 48px var(--text-shadow-glow);\n}\n\n.demo-page__lead {\n  font-size: 0.875rem;\n  line-height: 1.6;\n  color: var(--text-muted);\n  margin: 0 0 var(--space-lg);\n}\n\n.demo-legend {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: var(--space-xs);\n}\n\n.demo-legend__item {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n  font-family: var(--font-mono);\n  font-size: 0.75rem;\n  color: var(--text-muted);\n}\n\n.demo-legend__key {\n  flex: 0 0 4.5rem;\n  text-align: center;\n  font-family: var(--font-mono);\n  font-size: 0.75rem;\n  padding: 0.15em 0.4em;\n  border: 1px solid var(--accent-soft);\n  border-radius: 3px;\n  background: var(--bg-raised);\n  color: var(--parchment);\n}\n\n.demo-page__note {\n  margin: var(--space-lg) 0 0;\n  font-family: var(--font-mono);\n  font-size: 0.7rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--accent-hover);\n}\n\n.demo-page__credit {\n  margin: 0;\n  font-family: var(--font-mono);\n  font-size: 0.6875rem;\n  line-height: 1.5;\n  color: var(--text-muted);\n  opacity: 0.75;\n}\n\n/* Below this the canvas is wide enough to reach the rail, so the chrome drops\n   to a single translucent strip along the bottom and sheds its long copy. */\n@media (max-width: 1180px) {\n  /* Keep the board clear of the controls strip this breakpoint drops in. */\n  #textris-viewport {\n    bottom: 7rem !important;\n  }\n\n  .demo-page {\n    left: 0;\n    right: 0;\n    top: auto;\n    bottom: 0;\n    width: 100%;\n    max-height: none;\n    padding: var(--space-sm) var(--space-md);\n    background: var(--viewport-tint);\n    backdrop-filter: blur(2px);\n  }\n\n  .demo-page__panel {\n    padding: var(--space-sm) var(--space-md);\n    background: transparent;\n    border: 0;\n    box-shadow: none;\n    clip-path: none;\n  }\n\n  .demo-page__eyebrow,\n  .demo-page__lead,\n  .demo-page__credit {\n    display: none;\n  }\n\n  .demo-page__title {\n    font-size: 1.125rem;\n    margin: 0;\n  }\n\n  .demo-legend {\n    grid-auto-flow: column;\n    grid-auto-columns: max-content;\n    justify-content: start;\n    gap: var(--space-md);\n    margin-top: var(--space-xs);\n  }\n\n  .demo-page__note {\n    display: none;\n  }\n}\n\n@media (max-width: 768px) {\n  .docs-layout {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto minmax(0, 1fr);\n  }\n\n  .docs-sidebar-shell {\n    z-index: 20;\n    flex-shrink: 0;\n    overflow: visible;\n    background: var(--bg-deep);\n    border-bottom: 1px solid var(--accent-soft);\n  }\n\n  .docs-sidebar__toggle {\n    display: flex;\n    align-items: center;\n    gap: var(--space-sm);\n    width: 100%;\n    margin: 0;\n    padding: var(--space-sm) var(--space-md);\n    border: none;\n    border-radius: 0;\n    clip-path: none;\n    text-align: left;\n    box-shadow: none;\n  }\n\n  .docs-sidebar__toggle-label {\n    font-family: var(--font-mono);\n    font-size: 0.6875rem;\n    letter-spacing: 0.14em;\n    text-transform: uppercase;\n    color: var(--accent-soft);\n    flex-shrink: 0;\n  }\n\n  .docs-sidebar__toggle-current {\n    flex: 1;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    color: var(--parchment);\n  }\n\n  .docs-sidebar__toggle-icon {\n    flex-shrink: 0;\n    font-size: 0.625rem;\n    color: var(--accent-hover);\n  }\n\n  .docs-sidebar-shell:not(.docs-sidebar-shell--open) .docs-sidebar {\n    display: none;\n  }\n\n  .docs-sidebar-shell--open .docs-sidebar {\n    display: block;\n    position: static;\n    max-height: min(70vh, 28rem);\n    overflow-y: auto;\n    overscroll-behavior: contain;\n    border-right: none;\n    border-bottom: none;\n    clip-path: none;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);\n  }\n\n  .docs-content {\n    padding: var(--space-md) var(--space-md) var(--space-2xl);\n  }\n}\n\n/* ── Footer ── */\n\n.site-footer {\n  position: relative;\n  padding: var(--space-xl) var(--space-lg);\n  background: linear-gradient(0deg, var(--bg-deep) 0%, rgba(10, 16, 40, 0.92) 100%);\n  text-align: center;\n}\n\n.site-footer__rule {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    var(--accent) 20%,\n    var(--accent-hover) 50%,\n    var(--accent) 80%,\n    transparent\n  );\n  box-shadow: 0 0 12px var(--glow);\n}\n\n.site-footer__inner {\n  max-width: var(--content-max);\n  margin: 0 auto;\n}\n\n.site-footer__logo {\n  height: 1.5rem;\n  width: auto;\n  opacity: 0.9;\n  margin-bottom: var(--space-md);\n  filter: drop-shadow(0 0 8px var(--glow-soft));\n}\n\n.site-footer__list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.site-footer__item {\n  font-family: var(--font-mono);\n  font-size: 0.75rem;\n  letter-spacing: 0.04em;\n  color: var(--text-muted);\n}\n\n.site-footer__item + .site-footer__item {\n  margin-top: var(--space-xs);\n}\n\n.site-footer__item a {\n  color: var(--text-muted);\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.site-footer__item a:hover {\n  color: var(--accent-hover);\n}\n\n.site-footer__version {\n  margin-top: var(--space-md);\n  font-family: var(--font-mono);\n  font-size: 0.75rem;\n  letter-spacing: 0.1em;\n  color: var(--accent-soft);\n}\n\n@media (max-width: 640px) {\n  .site-header__nav {\n    gap: 0.15rem;\n  }\n\n  .site-header__link {\n    font-size: 0.6875rem;\n    padding: var(--space-xs);\n  }\n\n  .section-heading {\n    flex-wrap: wrap;\n    letter-spacing: 0.12em;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .hud-card:hover {\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
